import { useController, useFormContext } from 'react-hook-form'

import { FocusTarget } from '@/components/form/focus-target'
import { FileUpload } from '@/components/ui/file-upload'

import {
  FileUploadFormFieldAutoProps,
  FileUploadFormFieldManualProps,
  FileUploadFormFieldProps,
} from './file-upload-form-field.types'

export type {
  FileUploadFormFieldAutoProps,
  FileUploadFormFieldManualProps,
  FileUploadFormFieldProps,
}

export const FileUploadFormField = ({ name, ...props }: FileUploadFormFieldProps) => {
  const { control } = useFormContext()
  const { field, fieldState } = useController({ control, defaultValue: [], name })

  const error = fieldState.error?.message

  return (
    <FocusTarget fieldRef={field.ref}>
      {props.mode === 'auto' ? (
        <FileUpload
          {...props}
          error={error}
          files={field.value as string[]}
          onChange={field.onChange}
        />
      ) : (
        <FileUpload
          {...props}
          error={error}
          files={field.value as File[]}
          onChange={field.onChange}
        />
      )}
    </FocusTarget>
  )
}
